import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Observable, of, Subscription } from 'rxjs';
import { DataType } from 'src/app/core/models/document/custom-field-base-model';
import { DocumentStatus, TemplateDocumentType } from 'src/app/core/models/document/document-template-model';
import { MyfileModel } from 'src/app/core/models/myfile/myfile.model';
import { PaymentModel } from 'src/app/core/models/commerce/payment.model';
import { RequisitionModel } from 'src/app/core/models/requisition/requisition.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-myfile-modal',
  templateUrl: './myfile-modal.component.html',
  styleUrls: ['./myfile-modal.component.scss']
})
export class MyfileModalComponent implements OnInit {

  btnDisabled: boolean = false;
  activeStatus = 0;
  submitted: boolean = false;
  spinnerIsShown: boolean = false;

  datePattern = GlobalComponent.datePattern;
  disableEditing: boolean = true;

  @Input() myfile: MyfileModel = new MyfileModel();
  @Input() requisition: RequisitionModel | undefined;
  constructor(
    protected myFileApiService: MyfileApiService,
    protected authService: AuthMyfileService,
    protected modalRef: NgbActiveModal,
    protected pdfModalService: PdfViewerModalService,
    protected toasterNotificationService: ToasterNotificationService,
  ) { }

  ngOnInit(): void {
    if (this.myfile.status == DocumentStatus.New) {
      this.disableEditing = false;
    }
  }

  save() {
    this.submitted = false;
    this.spinnerIsShown = true;
    this.myFileApiService.updateMyFile(this.myfile).subscribe(() => {
      this.spinnerIsShown = false;
      this.modalRef.close();
    });

  }

  close() {
    this.modalRef.close();
  }

  stringLengthValidation(date: string | undefined): number {
    if (date == undefined) {
      return 0;
    } else {
      return date.length
    }
  }

  viewMyfile() {
    this.spinnerIsShown = true;
    this.myFileApiService.updateMyFile(this.myfile).subscribe(() => {

      if (this.requisition!.id && this.myfile.id) {
        this.myFileApiService.viewMyFile(this.requisition!.id, this.myfile.id).subscribe((result: any) => {
          this.pdfModalService.openModal(result, this.myfile.name);
          var sub: Subscription = this.pdfModalService.modelChanged.subscribe(() => {
            this.spinnerIsShown = false;
            sub.unsubscribe();
          })
        });
      }
      this.spinnerIsShown = false;

    });
  }

  printMyfile() {
    this.spinnerIsShown = true;
    this.submitted = false;
    this.myFileApiService.updateMyFile(this.myfile).subscribe(() => {

      if (this.myfile.sourceId && this.myfile.id) {
        this.myFileApiService.printMyFile(this.myfile.sourceId, this.myfile.id).subscribe((result: any) => {
          this.spinnerIsShown = false
        });
      } else {
        this.spinnerIsShown = false
      }

    });
  }


  getDocumentImageUrl(data: any) {
    if (data.imageUrl) {
      var filename = data.imageUrl.split('/').pop();
      if (filename.includes("120.png")) {
        filename = "myfile_border.jpg";
      }
      return environment.staticImageApiUrl + filename;
    }
    else {
      return GlobalComponent.defaultDocumentImageUrl;
    }
  }

}
